import {Types} from "@Common/types";

/**
 * Calculate a timezone's offset vs UTC
 * @returns {number} Offset in milliseconds
 */
export const mapTimeZoneNameAsOffset = (timeZone?:string): number => {
    const date      = new Date();
    const dateUtc   = new Date(new Intl.DateTimeFormat("en-US", {dateStyle: "short", timeStyle: "short", timeZone: "UTC"}).format(date));
    const dateTz    = new Date(new Intl.DateTimeFormat("en-US", {dateStyle: "short", timeStyle: "short", timeZone}).format(date));
    return dateTz.getTime() - dateUtc.getTime();
};

/**
 * @returns {Date} With timezone considered
 */
export const parsePhpDate = (php:Types.Apis.Models.PhpDate): Date => {
    const dateTzOffsetMs  = mapTimeZoneNameAsOffset(php.timezone);
    const localTzOffsetMs = mapTimeZoneNameAsOffset();
    return new Date(new Date(php.date.replace(" ", "T")).valueOf() - dateTzOffsetMs + localTzOffsetMs)
};

